export const enum UserRole {
  REPORT_VIEWER = 0,
  USER = 1,
  ADMIN = 2,
  DEV = 3,
}
